import { useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Layout } from "antd";

import UserHeader from "../../modules/learner/Header/Header";
import UserSidebar from "../../modules/learner/Sidebar/Sidebar";
import UserHomeScreen from "../../modules/learner/Home";
import UserDashboardScreen from "../../modules/learner/Dashboard";
import { selectUser } from "../../redux/auth/selector";
import { types } from "../../redux/auth/actions";
import Courses from "../../modules/learner/Course/View";
import CourseDetailsScreen from "../../modules/learner/Course/Details";
import Quizzie from "../../modules/learner/Quizzie/Form";
import Quizzies from "../../modules/learner/Quizzie/View";
import Results from "../../modules/shared/Results";
import CourseWatch from "../../modules/learner/Course/Watch";
import Alerts from "../../modules/learner/Alert/View";
import Modules from "../../modules/learner/Module/View";
import AIChat from "../../modules/learner/AIChat";
import ModuleDetailsScreen from "../../modules/learner/Module/Details";
import WildCardNavigation from "../../modules/shared/WildCardNavigation";
import CreateDiscussionScreen from "../../modules/learner/Discussion/Create";
import UserDiscussionScreen from "../../modules/learner/Discussion/View";
import LearnerAssignmentScreen from "../../modules/learner/Assignment/View";
import SingleAssignmentScreen from "../../modules/learner/Assignment/SingleAssignment";
import UserLessonDemandScreen from "../../modules/learner/LessonDemand/View";
import CreateLessonDemandScreen from "../../modules/learner/LessonDemand/Create";
import LearnerLessonDemandDetailsScreen from "../../modules/learner/LessonDemand/Details";
import UserOnboardingScreen from "../../modules/learner/Onboarding/View";
import UserOnboardingByIdScreen from "../../modules/learner/Onboarding/Details";
import UserTaskScreen from "../../modules/learner/Task/View";
import UserTaskDetailsScreen from "../../modules/learner/Task/Details";
import verlabLogoFooter from "../../assets/images/Verlab-footer.png";
import { selectCompanyInfo } from "../../redux/educator/selector";

const { Content, Footer } = Layout;

const UserLayout = () => {
  const loggedUser = useSelector(selectUser);
   const companyInfo = useSelector(selectCompanyInfo);
  const dispatch = useDispatch();
  useEffect(() => {
    if (!loggedUser) {
      dispatch({ type: types.GET_LOGGED_USER });
    }
  });

  return (
    <Layout style={{ minHeight: "100vh", padding: "0" }}>
      <UserSidebar></UserSidebar>

      <Layout>
        <UserHeader></UserHeader>

        <Content className="educator-container">
          <Routes>
            <Route path="home" element={<UserHomeScreen />} />
            <Route path="dashboard" element={<UserDashboardScreen />} />
            <Route path="module" element={<Modules />} />
            <Route path="module/:id" element={<ModuleDetailsScreen />} />
            <Route path="course" element={<Courses />} />
            <Route path="course/:id" element={<CourseDetailsScreen />} />
            <Route path="course/:id/lesson" element={<CourseWatch />} />
            <Route path="ai-chat" element={<AIChat />} />
            <Route
              path="quiz/results"
              element={<Results path="/user/quiz" />}
            />
            <Route path="alert" element={<Alerts />} />
            <Route path="quizzie" element={<Quizzies />} />
            <Route path="quizzie/:id" element={<Quizzie />} />
            <Route
              path="quizzie/results"
              element={<Results path="/user/quizzie" />}
            />
            <Route path="discussion" element={<UserDiscussionScreen />} />
            <Route
              path="discussion/create"
              element={<CreateDiscussionScreen />}
            />
            <Route
              path="discussion/results"
              element={<Results path="/user/discussion" />}
            />
            <Route path="assignment" element={<LearnerAssignmentScreen />} />
            <Route path="assignment/:id" element={<SingleAssignmentScreen />} />
            <Route path="lesson-demand" element={<UserLessonDemandScreen />} />
            <Route
              path="lesson-demand/create"
              element={<CreateLessonDemandScreen />}
            />
            <Route
              path="lesson-demand/:id"
              element={<LearnerLessonDemandDetailsScreen />}
            />
            <Route path="onboarding" element={<UserOnboardingScreen />} />
            <Route
              path="onboarding/:id"
              element={<UserOnboardingByIdScreen />}
            />

            <Route path="task" element={<UserTaskScreen />} />
            <Route path="task/:id" element={<UserTaskDetailsScreen />} />

            <Route path="*" element={<WildCardNavigation />} />
          </Routes>
        </Content>
         {companyInfo?.name === 'NanoThink' &&
          <Footer style={{ background: "rgb(21,34,85)", padding: "10px 30px" }}>
            <div className="flex gap-3 items-center">
              <img
                src={verlabLogoFooter}
                alt="Verlab Footer"
                style={{ width: "150px", height: "40px", objectFit: "contain" }}
              />
              <div className="text-xs text-white font-normal">
                This platform has been created through the NANO-THINK (101139436) project funded with support from the European Commission through Erasmus Virtual Exchanges in Higher Education and Youth programme. The platform reflects the views only of the author, and the Commission cannot be held responsible for any use which may be made of the information contained therein.
              </div>
            </div>
          </Footer>
        }
      </Layout>
    </Layout>
  );
};

export default UserLayout;
